// Extended mock people data with full profile information
export const mockPeople = [
    {
        id: 1,
        name: "Sarah Chen",
        primaryPhoto: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1517841905240-472988babdf9?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1200&h=400&fit=crop",
        accolades: "Forbes 30 Under 30 • Tech Innovator",
        tags: ["physio", "rehab", "flexibility"],
        roles: ["Physiotherapist", "Sports Rehab Specialist"],
        rating: 4.9,
        reviewCount: 127,
        hoverInfo: {
            bio: "Passionate about building bridges between tech and humanity",
            skills: ["AI/ML", "Product Strategy", "Mentorship"],
            connectionReason: "Looking to mentor aspiring founders"
        },
        profile: {
            bio: "With over 10 years of experience in physiotherapy and sports rehabilitation, I've helped hundreds of athletes return to peak performance. My approach combines evidence-based techniques with cutting-edge technology to deliver personalized treatment plans that get results.",
            qualifications: [
                { title: "Doctor of Physical Therapy", institution: "Stanford University", year: 2014 },
                { title: "Sports Rehabilitation Certification", institution: "American Sports Medicine Institute", year: 2016 },
                { title: "Dry Needling Specialist", institution: "Integrative Dry Needling", year: 2018 }
            ],
            specializations: ["Sports Injuries", "Post-Surgery Rehab", "Chronic Pain Management", "Movement Analysis"],
            languages: ["English", "Mandarin"],
            location: "San Francisco Bay Area"
        },
        services: [
            { id: "s1", name: "Physio Sessions", price: 120, period: "session", description: "1-on-1 physiotherapy sessions" },
            { id: "s2", name: "Monthly Rehab Program", price: 450, period: "month", description: "Comprehensive rehabilitation program with weekly check-ins" },
            { id: "s3", name: "Virtual Consultation", price: 80, period: "session", description: "Remote assessment and guidance" }
        ],
        posts: [
            { id: "p1", content: "Just wrapped up an amazing recovery journey with one of my clients. From ACL tear to running marathons again! 🏃‍♂️ The key? Patience, consistency, and trust in the process.", image: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600&h=400&fit=crop", date: "2024-01-15", likes: 234, comments: 45 },
            { id: "p2", content: "New blog post: '5 Stretches Every Desk Worker Needs' - Link in bio! Your lower back will thank you.", date: "2024-01-10", likes: 189, comments: 32 },
            { id: "p3", content: "Attending the Sports Medicine Conference next week. Who else will be there? Let's connect! 🤝", image: "https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=600&h=400&fit=crop", date: "2024-01-05", likes: 156, comments: 28 }
        ],
        workouts: [
            { id: "w1", title: "Hip Mobility Routine", focus: "Flexibility", difficulty: "Beginner", duration: "20 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=300&h=200&fit=crop" },
            { id: "w2", title: "ACL Recovery Phase 1", focus: "Rehab", difficulty: "Beginner", duration: "30 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=300&h=200&fit=crop" },
            { id: "w3", title: "Runner's Strength Program", focus: "Strength", difficulty: "Intermediate", duration: "45 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Michael T.", rating: 5, text: "Sarah helped me recover from a shoulder injury in record time. Her expertise and positive attitude made every session enjoyable.", date: "2024-01-12", verified: true },
            { id: "r2", author: "Jennifer L.", rating: 5, text: "Best physio I've ever worked with. She really takes the time to understand your goals and creates a personalized plan.", date: "2024-01-08", verified: true },
            { id: "r3", author: "David K.", rating: 4, text: "Great results, very knowledgeable. Sometimes appointments run a bit late but worth the wait.", date: "2023-12-28", verified: true }
        ]
    },
    {
        id: 2,
        name: "Marcus Johnson",
        primaryPhoto: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&h=400&fit=crop",
        accolades: "TEDx Speaker • Community Builder",
        tags: ["PT", "muscle building", "endurance"],
        roles: ["Personal Trainer", "Strength Coach"],
        rating: 4.8,
        reviewCount: 203,
        hoverInfo: {
            bio: "Connecting people through shared experiences and stories",
            skills: ["Public Speaking", "Community", "Leadership"],
            connectionReason: "Eager to collaborate on social impact projects"
        },
        profile: {
            bio: "Former professional athlete turned certified personal trainer. I specialize in strength training and building sustainable fitness habits. My philosophy is simple: train smart, stay consistent, and enjoy the journey.",
            qualifications: [
                { title: "Certified Strength & Conditioning Specialist", institution: "NSCA", year: 2015 },
                { title: "Sports Nutrition Certification", institution: "Precision Nutrition", year: 2017 },
                { title: "Kettlebell Instructor", institution: "RKC", year: 2019 }
            ],
            specializations: ["Strength Training", "Athletic Performance", "Body Composition", "Functional Fitness"],
            languages: ["English", "Spanish"],
            location: "Los Angeles, CA"
        },
        services: [
            { id: "s1", name: "Personal Training", price: 100, period: "session", description: "1-on-1 personal training sessions" },
            { id: "s2", name: "Monthly Coaching", price: 399, period: "month", description: "Custom programming with weekly check-ins" },
            { id: "s3", name: "Group Training", price: 40, period: "session", description: "Small group sessions (max 6 people)" }
        ],
        posts: [
            { id: "p1", content: "Progress isn't always linear, but it's always worth it. Keep pushing! 💪", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&h=400&fit=crop", date: "2024-01-14", likes: 312, comments: 67 },
            { id: "p2", content: "Today's reminder: Your only competition is who you were yesterday.", date: "2024-01-11", likes: 245, comments: 41 }
        ],
        workouts: [
            { id: "w1", title: "Full Body Strength", focus: "Strength", difficulty: "Intermediate", duration: "50 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1581009146145-b5ef050c149a?w=300&h=200&fit=crop" },
            { id: "w2", title: "Hypertrophy Upper Body", focus: "Muscle Building", difficulty: "Intermediate", duration: "60 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1583454110551-21f2fa2afe61?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Sarah M.", rating: 5, text: "Marcus transformed my approach to fitness. Down 30 lbs and stronger than ever!", date: "2024-01-10", verified: true },
            { id: "r2", author: "Tom H.", rating: 5, text: "Incredible coach. Knows how to push you while keeping you safe.", date: "2024-01-05", verified: true }
        ]
    },
    {
        id: 3,
        name: "Elena Rodriguez",
        primaryPhoto: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=1200&h=400&fit=crop",
        accolades: "Wellness Expert • Author",
        tags: ["weight loss", "nutrition", "flexibility"],
        roles: ["Nutritionist", "Wellness Coach"],
        rating: 4.9,
        reviewCount: 156,
        hoverInfo: {
            bio: "Helping others find balance in a chaotic world",
            skills: ["Mindfulness", "Writing", "Coaching"],
            connectionReason: "Open to wellness collaboration opportunities"
        },
        profile: {
            bio: "Registered dietitian and wellness advocate with a passion for helping people develop a healthy relationship with food. I believe in sustainable nutrition that fits your lifestyle, not restrictive diets that leave you frustrated.",
            qualifications: [
                { title: "Registered Dietitian", institution: "Academy of Nutrition and Dietetics", year: 2013 },
                { title: "Certified Wellness Coach", institution: "Wellcoaches", year: 2016 },
                { title: "Mindful Eating Specialist", institution: "Center for Mindful Eating", year: 2020 }
            ],
            specializations: ["Weight Management", "Intuitive Eating", "Sports Nutrition", "Meal Planning"],
            languages: ["English", "Spanish", "Portuguese"],
            location: "Miami, FL"
        },
        services: [
            { id: "s1", name: "Nutrition Consultation", price: 95, period: "session", description: "Comprehensive nutrition assessment" },
            { id: "s2", name: "Monthly Nutrition Plan", price: 299, period: "month", description: "Custom meal plans and weekly check-ins" },
            { id: "s3", name: "Group Wellness Program", price: 149, period: "month", description: "8-week group transformation program" }
        ],
        posts: [
            { id: "p1", content: "Meal prep Sunday! Here's my go-to weekly prep that takes only 2 hours. Save this for later! 🥗", image: "https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=600&h=400&fit=crop", date: "2024-01-14", likes: 423, comments: 89 },
            { id: "p2", content: "Stop calling foods 'good' or 'bad'. All foods can fit in a balanced diet. It's about context and moderation.", date: "2024-01-12", likes: 567, comments: 112 }
        ],
        workouts: [
            { id: "w1", title: "Morning Yoga Flow", focus: "Flexibility", difficulty: "Beginner", duration: "25 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=300&h=200&fit=crop" },
            { id: "w2", title: "Stress Relief Stretching", focus: "Wellness", difficulty: "Beginner", duration: "15 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Amanda R.", rating: 5, text: "Elena helped me break free from yo-yo dieting. I finally have a healthy relationship with food!", date: "2024-01-11", verified: true },
            { id: "r2", author: "Chris P.", rating: 5, text: "The meal plans are delicious and easy to follow. Lost 20 lbs without feeling deprived.", date: "2024-01-07", verified: true }
        ]
    },
    {
        id: 4,
        name: "David Kim",
        primaryPhoto: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1461896836934- voices-31?w=1200&h=400&fit=crop",
        accolades: "Serial Entrepreneur • Angel Investor",
        tags: ["biokineticist", "sprinting", "endurance"],
        roles: ["Biokineticist", "Movement Specialist"],
        rating: 4.7,
        reviewCount: 89,
        hoverInfo: {
            bio: "Building the future one startup at a time",
            skills: ["Venture Capital", "Strategy", "Networking"],
            connectionReason: "Always looking for the next big idea"
        },
        profile: {
            bio: "Board-certified biokineticist specializing in movement optimization and injury prevention. I work with athletes from recreational to professional levels to enhance performance through biomechanical analysis and corrective exercise.",
            qualifications: [
                { title: "Master's in Biokinetics", institution: "University of Cape Town", year: 2012 },
                { title: "Certified Movement Specialist", institution: "FMS", year: 2015 },
                { title: "Sports Performance Coach", institution: "EXOS", year: 2018 }
            ],
            specializations: ["Biomechanics", "Sprint Mechanics", "Injury Prevention", "Performance Testing"],
            languages: ["English", "Korean"],
            location: "Seattle, WA"
        },
        services: [
            { id: "s1", name: "Biomechanical Assessment", price: 200, period: "session", description: "Full movement screening and analysis" },
            { id: "s2", name: "Sprint Coaching", price: 150, period: "session", description: "Speed development training" },
            { id: "s3", name: "Performance Package", price: 599, period: "month", description: "Weekly sessions + video analysis" }
        ],
        posts: [
            { id: "p1", content: "Fascinating case study: How fixing hip mobility improved this sprinter's 100m time by 0.3 seconds 🏃‍♂️⚡", image: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=600&h=400&fit=crop", date: "2024-01-13", likes: 189, comments: 34 }
        ],
        workouts: [
            { id: "w1", title: "Sprint Drills Fundamentals", focus: "Speed", difficulty: "Intermediate", duration: "35 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=300&h=200&fit=crop" },
            { id: "w2", title: "Plyometric Power", focus: "Explosiveness", difficulty: "Advanced", duration: "40 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1550259979-ed79b48d2a30?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Kevin L.", rating: 5, text: "David's biomechanical analysis was eye-opening. Fixed issues I didn't even know I had.", date: "2024-01-09", verified: true }
        ]
    },
    {
        id: 5,
        name: "Aisha Patel",
        primaryPhoto: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1200&h=400&fit=crop",
        accolades: "Creative Director • Design Thinker",
        tags: ["physio", "rehab", "muscle building"],
        roles: ["Physical Therapist", "Strength Coach"],
        rating: 4.8,
        reviewCount: 112,
        hoverInfo: {
            bio: "Transforming ideas into visual experiences",
            skills: ["UX Design", "Branding", "Creative Strategy"],
            connectionReason: "Seeking creative collaborators"
        },
        profile: {
            bio: "Dual-certified in physical therapy and strength training, I bridge the gap between rehabilitation and performance. My mission is to help you not just recover, but come back stronger than before.",
            qualifications: [
                { title: "Doctor of Physical Therapy", institution: "NYU", year: 2015 },
                { title: "CSCS", institution: "NSCA", year: 2017 },
                { title: "Orthopedic Clinical Specialist", institution: "ABPTS", year: 2020 }
            ],
            specializations: ["Post-Surgical Rehab", "Return to Sport", "Strength Training", "Manual Therapy"],
            languages: ["English", "Hindi", "Gujarati"],
            location: "New York, NY"
        },
        services: [
            { id: "s1", name: "PT Evaluation", price: 175, period: "session", description: "Initial assessment and treatment plan" },
            { id: "s2", name: "Rehab + Strength Program", price: 549, period: "month", description: "Combined PT and strength coaching" }
        ],
        posts: [
            { id: "p1", content: "Return to sport protocols aren't one-size-fits-all. Here's how I customize them for each athlete 🏆", image: "https://images.unsplash.com/photo-1576678927484-cc907957088c?w=600&h=400&fit=crop", date: "2024-01-12", likes: 234, comments: 45 }
        ],
        workouts: [
            { id: "w1", title: "Shoulder Stability Circuit", focus: "Rehab", difficulty: "Beginner", duration: "20 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Ryan T.", rating: 5, text: "Aisha got me back to playing basketball after my ACL surgery. Can't thank her enough!", date: "2024-01-08", verified: true }
        ]
    },
    {
        id: 6,
        name: "James Mitchell",
        primaryPhoto: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1492562080023-ab3db95bfbce?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&h=400&fit=crop",
        accolades: "Fitness Coach • Motivational Speaker",
        tags: ["PT", "weight loss", "muscle building"],
        roles: ["Personal Trainer", "Transformation Coach"],
        rating: 4.9,
        reviewCount: 287,
        hoverInfo: {
            bio: "Empowering people to become their best selves",
            skills: ["Fitness", "Nutrition", "Motivation"],
            connectionReason: "Ready to help you achieve your goals"
        },
        profile: {
            bio: "Helped over 500 clients achieve their body transformation goals. I specialize in sustainable fat loss and muscle building for busy professionals who want results without living in the gym.",
            qualifications: [
                { title: "Certified Personal Trainer", institution: "ACE", year: 2012 },
                { title: "Nutrition Coach", institution: "Precision Nutrition", year: 2014 },
                { title: "Behavior Change Specialist", institution: "ACE", year: 2019 }
            ],
            specializations: ["Body Transformation", "Fat Loss", "Muscle Building", "Lifestyle Coaching"],
            languages: ["English"],
            location: "Chicago, IL"
        },
        services: [
            { id: "s1", name: "Transformation Coaching", price: 499, period: "month", description: "Complete transformation program with daily support" },
            { id: "s2", name: "1-on-1 Training", price: 120, period: "session", description: "In-person or virtual training sessions" }
        ],
        posts: [
            { id: "p1", content: "12-week transformation results! So proud of this client's dedication. Proof that consistency beats perfection every time 💪", image: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=600&h=400&fit=crop", date: "2024-01-15", likes: 678, comments: 123 }
        ],
        workouts: [
            { id: "w1", title: "Fat Burning HIIT", focus: "Weight Loss", difficulty: "Intermediate", duration: "30 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?w=300&h=200&fit=crop" },
            { id: "w2", title: "Muscle Building Basics", focus: "Hypertrophy", difficulty: "Beginner", duration: "45 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1581009146145-b5ef050c149a?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Michelle K.", rating: 5, text: "James changed my life. Down 45 lbs and I've kept it off for 2 years now!", date: "2024-01-14", verified: true },
            { id: "r2", author: "Robert J.", rating: 5, text: "Best investment I've made in myself. The accountability is incredible.", date: "2024-01-10", verified: true }
        ]
    },
    {
        id: 7,
        name: "Maya Thompson",
        primaryPhoto: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1200&h=400&fit=crop",
        accolades: "Social Entrepreneur • Changemaker",
        tags: ["biokineticist", "endurance", "sprinting"],
        roles: ["Biokineticist", "Endurance Coach"],
        rating: 4.6,
        reviewCount: 67,
        hoverInfo: {
            bio: "Creating sustainable solutions for tomorrow",
            skills: ["Sustainability", "Social Impact", "Innovation"],
            connectionReason: "Building a network of conscious leaders"
        },
        profile: {
            bio: "Specialized in endurance sports and long-distance running. I help athletes of all levels improve their aerobic capacity, race strategy, and mental toughness to achieve their endurance goals.",
            qualifications: [
                { title: "Biokinetics Degree", institution: "Stellenbosch University", year: 2014 },
                { title: "Endurance Running Coach", institution: "RRCA", year: 2017 },
                { title: "Heart Rate Training Specialist", institution: "TrainingPeaks", year: 2019 }
            ],
            specializations: ["Marathon Training", "Ultra Running", "Triathlon", "VO2 Max Testing"],
            languages: ["English", "French"],
            location: "Denver, CO"
        },
        services: [
            { id: "s1", name: "Running Assessment", price: 150, period: "session", description: "Gait analysis and training zones" },
            { id: "s2", name: "Marathon Prep Program", price: 349, period: "month", description: "16-week marathon training plan" }
        ],
        posts: [
            { id: "p1", content: "Trail running season is here! Here are my top 5 trails in Colorado 🏔️", image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=600&h=400&fit=crop", date: "2024-01-11", likes: 189, comments: 34 }
        ],
        workouts: [
            { id: "w1", title: "Base Building Run", focus: "Endurance", difficulty: "Beginner", duration: "45 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Lisa M.", rating: 5, text: "Ran my first marathon thanks to Maya's program. Couldn't have done it without her!", date: "2024-01-06", verified: true }
        ]
    },
    {
        id: 8,
        name: "Ryan O'Connor",
        primaryPhoto: "https://images.unsplash.com/photo-1463453091185-61582044d556?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1507591064344-4c6ce005b128?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=1200&h=400&fit=crop",
        accolades: "Music Producer • Artist",
        tags: ["physio", "nutrition", "rehab"],
        roles: ["Physiotherapist", "Nutritionist"],
        rating: 4.7,
        reviewCount: 94,
        hoverInfo: {
            bio: "Creating soundscapes that move the soul",
            skills: ["Music Production", "Songwriting", "Collaboration"],
            connectionReason: "Looking for creative partnerships"
        },
        profile: {
            bio: "Combining physiotherapy with nutrition science for a holistic approach to health. I specialize in helping performers and musicians overcome occupational injuries and optimize their health.",
            qualifications: [
                { title: "BSc Physiotherapy", institution: "University of Dublin", year: 2013 },
                { title: "Sports Nutrition Diploma", institution: "ISSA", year: 2016 },
                { title: "Performing Arts Medicine Certificate", institution: "PAMA", year: 2020 }
            ],
            specializations: ["Musicians' Health", "Repetitive Strain", "Nutrition Counseling", "Posture Correction"],
            languages: ["English", "Irish"],
            location: "Boston, MA"
        },
        services: [
            { id: "s1", name: "Physio Session", price: 110, period: "session", description: "Treatment and rehabilitation" },
            { id: "s2", name: "Nutrition + Physio Combo", price: 399, period: "month", description: "Holistic health optimization" }
        ],
        posts: [
            { id: "p1", content: "Musicians: here's why your posture matters more than your practice time ⌨️🎸", date: "2024-01-13", likes: 145, comments: 28 }
        ],
        workouts: [
            { id: "w1", title: "Desk Worker Mobility", focus: "Rehab", difficulty: "Beginner", duration: "15 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Emma S.", rating: 5, text: "Ryan fixed my wrist pain that was affecting my piano playing. Highly recommend!", date: "2024-01-07", verified: true }
        ]
    },
    {
        id: 9,
        name: "Zoe Williams",
        primaryPhoto: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1524504388940-b1c1722653e1?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1545205597-3d9d02c29597?w=1200&h=400&fit=crop",
        accolades: "Life Coach • Podcast Host",
        tags: ["weight loss", "flexibility", "nutrition"],
        roles: ["Wellness Coach", "Yoga Instructor"],
        rating: 4.9,
        reviewCount: 178,
        hoverInfo: {
            bio: "Guiding you through life's biggest transitions",
            skills: ["Coaching", "Podcasting", "Personal Growth"],
            connectionReason: "Excited to share wisdom and learn from others"
        },
        profile: {
            bio: "Certified yoga instructor and wellness coach helping people find balance through movement, mindful eating, and self-compassion. Host of the 'Balanced Living' podcast with over 1M downloads.",
            qualifications: [
                { title: "RYT-500 Yoga Teacher", institution: "Yoga Alliance", year: 2015 },
                { title: "Health Coach Certification", institution: "IIN", year: 2017 },
                { title: "Mindfulness-Based Stress Reduction", institution: "UCSD", year: 2019 }
            ],
            specializations: ["Yoga Therapy", "Mindful Eating", "Stress Management", "Weight Wellness"],
            languages: ["English", "German"],
            location: "Austin, TX"
        },
        services: [
            { id: "s1", name: "Yoga Private Session", price: 85, period: "session", description: "Personalized yoga practice" },
            { id: "s2", name: "Wellness Coaching", price: 299, period: "month", description: "Holistic lifestyle transformation" }
        ],
        posts: [
            { id: "p1", content: "New podcast episode: 'Why Your Morning Routine is Sabotaging Your Weight Loss' 🎧", image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600&h=400&fit=crop", date: "2024-01-14", likes: 345, comments: 67 }
        ],
        workouts: [
            { id: "w1", title: "Gentle Morning Yoga", focus: "Flexibility", difficulty: "Beginner", duration: "30 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=300&h=200&fit=crop" },
            { id: "w2", title: "Power Yoga Flow", focus: "Strength", difficulty: "Intermediate", duration: "45 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1599901860904-17e6ed7083a0?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Patricia H.", rating: 5, text: "Zoe's approach to wellness changed everything for me. I finally feel at peace with my body.", date: "2024-01-12", verified: true },
            { id: "r2", author: "Daniel R.", rating: 5, text: "The podcast alone is worth its weight in gold. The coaching? Life-changing.", date: "2024-01-09", verified: true }
        ]
    },
    {
        id: 10,
        name: "Chris Anderson",
        primaryPhoto: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1519345182560-3f2917c472ef?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=1200&h=400&fit=crop",
        accolades: "Sports Scientist • Performance Coach",
        tags: ["biokineticist", "sprinting", "muscle building"],
        roles: ["Sports Scientist", "Performance Coach"],
        rating: 4.8,
        reviewCount: 134,
        hoverInfo: {
            bio: "Data-driven approach to peak performance",
            skills: ["Biomechanics", "Data Analysis", "Training"],
            connectionReason: "Seeking athletes for research collaboration"
        },
        profile: {
            bio: "PhD in Sports Science with a focus on human performance optimization. I combine cutting-edge research with practical coaching to help athletes reach their genetic potential.",
            qualifications: [
                { title: "PhD Sports Science", institution: "Loughborough University", year: 2016 },
                { title: "CSCS", institution: "NSCA", year: 2014 },
                { title: "Performance Analytics Certificate", institution: "MIT", year: 2021 }
            ],
            specializations: ["Performance Testing", "Periodization", "Sprint Training", "Recovery Science"],
            languages: ["English"],
            location: "Phoenix, AZ"
        },
        services: [
            { id: "s1", name: "Performance Testing", price: 250, period: "session", description: "Comprehensive athletic assessment" },
            { id: "s2", name: "Elite Coaching Program", price: 699, period: "month", description: "Science-based training program" }
        ],
        posts: [
            { id: "p1", content: "New research: Optimal rest periods for power development. Thread 🧵👇", image: "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?w=600&h=400&fit=crop", date: "2024-01-15", likes: 234, comments: 56 }
        ],
        workouts: [
            { id: "w1", title: "Power Development", focus: "Explosiveness", difficulty: "Advanced", duration: "50 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1550259979-ed79b48d2a30?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Jason M.", rating: 5, text: "Chris's data-driven approach helped me shave 0.5 seconds off my 100m time.", date: "2024-01-11", verified: true }
        ]
    },
    {
        id: 11,
        name: "Nina Torres",
        primaryPhoto: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1571019614242-c5c5dee9f50b?w=1200&h=400&fit=crop",
        accolades: "Physical Therapist • Movement Specialist",
        tags: ["physio", "rehab", "flexibility"],
        roles: ["Physical Therapist", "Pilates Instructor"],
        rating: 4.9,
        reviewCount: 203,
        hoverInfo: {
            bio: "Restoring movement, restoring life",
            skills: ["Manual Therapy", "Exercise Prescription", "Pain Management"],
            connectionReason: "Open to patient referrals and partnerships"
        },
        profile: {
            bio: "Board-certified orthopedic physical therapist with additional certification in clinical Pilates. I specialize in chronic pain management and helping clients regain their quality of life through movement.",
            qualifications: [
                { title: "DPT", institution: "USC", year: 2012 },
                { title: "Orthopedic Clinical Specialist", institution: "ABPTS", year: 2016 },
                { title: "Pilates Method Alliance Certified", institution: "PMA", year: 2018 }
            ],
            specializations: ["Chronic Pain", "Spinal Disorders", "Clinical Pilates", "Manual Therapy"],
            languages: ["English", "Spanish"],
            location: "San Diego, CA"
        },
        services: [
            { id: "s1", name: "PT Session", price: 160, period: "session", description: "One-on-one physical therapy" },
            { id: "s2", name: "Pilates Rehab", price: 120, period: "session", description: "Clinical Pilates for rehabilitation" }
        ],
        posts: [
            { id: "p1", content: "Your back pain might not be about your back at all. Here's why hip mobility matters 🦴", image: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600&h=400&fit=crop", date: "2024-01-10", likes: 289, comments: 54 }
        ],
        workouts: [
            { id: "w1", title: "Lower Back Relief", focus: "Rehab", difficulty: "Beginner", duration: "20 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=300&h=200&fit=crop" },
            { id: "w2", title: "Core Stability Pilates", focus: "Strength", difficulty: "Intermediate", duration: "35 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1518611012118-696072aa579a?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "George B.", rating: 5, text: "After years of chronic back pain, Nina finally helped me find relief. Miracle worker!", date: "2024-01-08", verified: true },
            { id: "r2", author: "Karen L.", rating: 5, text: "The Pilates sessions are transformative. I stand taller and move better than I have in years.", date: "2024-01-04", verified: true }
        ]
    },
    {
        id: 12,
        name: "Alex Rivera",
        primaryPhoto: "https://images.unsplash.com/photo-1507537297725-24a1c029d3ca?w=400&h=500&fit=crop",
        secondaryPhoto: "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?w=400&h=500&fit=crop",
        coverPhoto: "https://images.unsplash.com/photo-1552674605-db6ffd4facb5?w=1200&h=400&fit=crop",
        accolades: "Marathon Runner • Endurance Coach",
        tags: ["endurance", "nutrition", "sprinting"],
        roles: ["Running Coach", "Sports Nutritionist"],
        rating: 4.7,
        reviewCount: 156,
        hoverInfo: {
            bio: "Pushing limits, one mile at a time",
            skills: ["Endurance Training", "Race Strategy", "Mental Toughness"],
            connectionReason: "Looking for running community connections"
        },
        profile: {
            bio: "2x Boston Marathon qualifier and certified running coach. I combine endurance coaching with sports nutrition to help runners fuel their best performances and reach new personal records.",
            qualifications: [
                { title: "RRCA Certified Running Coach", institution: "RRCA", year: 2015 },
                { title: "Sports Nutrition Specialist", institution: "ISSN", year: 2017 },
                { title: "USA Track & Field Level 2", institution: "USATF", year: 2019 }
            ],
            specializations: ["Marathon Training", "5K-Half Marathon", "Race Nutrition", "Speed Work"],
            languages: ["English", "Spanish"],
            location: "Portland, OR"
        },
        services: [
            { id: "s1", name: "Running Coaching", price: 199, period: "month", description: "Custom training plans with weekly check-ins" },
            { id: "s2", name: "Race Nutrition Plan", price: 149, period: "plan", description: "Personalized fueling strategy" }
        ],
        posts: [
            { id: "p1", content: "Race day nutrition mistakes I see all the time (and how to fix them) 🍌⚡", image: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=600&h=400&fit=crop", date: "2024-01-14", likes: 278, comments: 45 }
        ],
        workouts: [
            { id: "w1", title: "Speed Intervals", focus: "Speed", difficulty: "Intermediate", duration: "40 min", isSubscriberOnly: false, thumbnail: "https://images.unsplash.com/photo-1461896836934-ffe607ba8211?w=300&h=200&fit=crop" },
            { id: "w2", title: "Long Run Strategy", focus: "Endurance", difficulty: "Intermediate", duration: "90 min", isSubscriberOnly: true, thumbnail: "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?w=300&h=200&fit=crop" }
        ],
        reviews: [
            { id: "r1", author: "Steve C.", rating: 5, text: "Qualified for Boston with Alex's coaching! The training plan was perfectly tailored to my schedule.", date: "2024-01-13", verified: true },
            { id: "r2", author: "Maria G.", rating: 4, text: "Great coach who really knows running. Nutrition advice was a game-changer.", date: "2024-01-09", verified: true }
        ]
    }
];

export const getPersonById = (id) => {
    return mockPeople.find(person => person.id === parseInt(id));
};

export const FILTER_OPTIONS = [
    'biokineticist',
    'physio',
    'PT',
    'weight loss',
    'muscle building',
    'sprinting',
    'endurance',
    'rehab',
    'nutrition',
    'flexibility'
];
